import { getQueryClient } from '@bonusly/query-client';

import { meQueryKey, MeResponse } from '../../queries/profile';
import { Company } from '../company';
import { useIdentityStore } from '../store';
import { User } from '../user';

export const refetchProfile = async (): Promise<{
	company: Company;
	user: User;
}> => {
	const queryClient = await getQueryClient();
	await queryClient.invalidateQueries({ queryKey: meQueryKey });
	const data = queryClient.getQueryData<MeResponse>(meQueryKey);

	if (data) {
		// Write updated data back to Zustand so hooks/getters see the update
		useIdentityStore.setState({
			company: data.company,
			features: data.features,
			user: data.user,
		});

		return { company: data.company, user: data.user };
	}

	// Fallback: return current Zustand state
	const state = useIdentityStore.getState();
	return { company: state.company, user: state.user };
};
